export default __webpack_public_path__ + "static/media/Polygon.c952329f.svg";